module.exports = __webpack_public_path__ + "static/media/LC.2aaea6f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LC.svg
// module id = 298
// module chunks = 0